import React, { useEffect, useState } from "react";
import { Row, Card, Tab, Nav, Modal, Spinner, Button } from "react-bootstrap";
import { Profile, TableDocument, Teacher, Information, Profile2User, Health, MedalStar, DocumentText, ArrangeHorizontal, UserSquare, Card as CardIcon } from "iconsax-react";
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import IdsPlayer from "../../../../components/Clienti/ids_player";
import DatiSportPlayer from "../../../../components/Clienti/datiSportivi_player";
import DatiSanPlayer from "../../../../components/Clienti/datiSanitari_player";
import FormaFisPlayer from "../../../../components/Clienti/formaFisica_player";
import TraguardiPlayer from "../../../../components/Clienti/traguardi_player";
import StudiPlayer from "../../../../components/Clienti/Studi_player";
import DocumentiPlayer from "../../../../components/Clienti/documenti_player";
import JuniorPlayer from "../../../../components/Clienti/junior_player";
import AssociazioniPlayer from "../../../../components/Clienti/associazioni_player";
import TesseramentiPlayer from "../../../../components/Clienti/tesseramenti_player";
import { usePageTitle, useStatoInSolaLettura, statoProfilo } from "../../../../layouts/PageHeaderExtra";
import MyApiClient from "../../../../../api-client/MyApiClient";
import DynamicLogo from "../../../DynamicLogoLoader";
import DEFAULT_USER from "../../../../../images/DEFAULT_USER.png";
import { useModificaAnagrafica, TastiModifica, FinestraModificaNonSalvata } from "../../../../components/SuperAdmin/Anagrafiche/modificaAnagrafica";
import DatiAnagraficiModifica from "../../../../components/SuperAdmin/Anagrafiche/DatiAnagraficiModifica";
import DatiSportiviModifica from "../../../../components/SuperAdmin/Anagrafiche/DatiSportiviModifica";
import DatiSanitariModifica from "../../../../components/SuperAdmin/Anagrafiche/DatiSanitariModifica";
import FormaFisicaModifica from "../../../../components/SuperAdmin/Anagrafiche/FormaFisicaModifica";

// Tab che apre ciascun gruppo di campi quando c'e' un dato da sistemare
const TAB_DEL_GRUPPO = { anagrafica: 'ids', sport: 'datisportivi', salute: 'datisanitari', forma: 'formafisica' };

export const PlayerEdit = () => {

	const { id } = useParams();

	const [loadingShowed, setLoadingShowed] = useState(false);

	const [profile, setProfile] = useState(null);
	const [privateProfile, setPrivateProfile] = useState(null);
	const [labelNome, setLabelNome] = useState('');
	// Titolo della pagina = nome e cognome, appena caricati.
	usePageTitle(labelNome);
	// Stato del profilo in sola lettura accanto al titolo (manca l'API per cambiarlo)
	const statoProf = statoProfilo(profile?.idsPlay?.profileStatus);
	useStatoInSolaLettura(statoProf.label, statoProf.tono);

	const navigate = useNavigate();
	// Super admin: i dati del profilo si modificano (interruttore SUPERADMIN_PUO_MODIFICARE); spento, tutto in sola lettura
	const modifica = useModificaAnagrafica(id, 'player', '/superadmin/anagrafiche/player');
	const inModifica = modifica.pronto;
	// «Elimina»: era nel menu a fine riga della lista, ora sta nella scheda (03/10/2026).
	const [confermaElimina, setConfermaElimina] = useState(false);
	const [erroreElimina, setErroreElimina] = useState('');

	const eliminaPlayer = async () => {
		setConfermaElimina(false);
		const tokenDetailsString = sessionStorage.getItem('userDetails');
		if (!tokenDetailsString) return;
		const token = JSON.parse(tokenDetailsString).idToken;
		setLoadingShowed(true);
		const deleteResult = await new MyApiClient().deleteProfile(token, id);
		setLoadingShowed(false);
		if (deleteResult) {
			setErroreElimina(deleteResult);
		} else {
			navigate('/superadmin/anagrafiche/player');
		}
	};

	const tabData = [
		{
			id: 'ids',
			name: "IDS",
			icon: <Profile size='18' variant='Bulk' />,
			content: inModifica
				? <DatiAnagraficiModifica tipo="player" modifica={modifica} email={profile?.idsPlay?.email} />
				: <IdsPlayer isDisabled={true} profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'datisportivi',
			name: "Dati sportivi",
			icon: <TableDocument size='18' />,
            content: inModifica
				? <DatiSportiviModifica modifica={modifica} />
				: <DatiSportPlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'datisanitari',
			name: "Dati sanitari",
			icon: <Health size='18' />,
			content: inModifica
				? <DatiSanitariModifica tipo="player" modifica={modifica} />
				: <DatiSanPlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'formafisica',
			name: "Forma fisica",
			icon: <Health variant="Bulk" size='18' />,
			content: inModifica
				? <FormaFisicaModifica tipo="player" modifica={modifica} />
				: <FormaFisPlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'traguardi',
			name: "Traguardi",
			icon: <MedalStar size='18' variant="Bulk" />,
			content: <TraguardiPlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'studi',
			name: "Studi",
			icon: <Teacher size='18' />,
			content: <StudiPlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'documenti',
			name: "Documenti",
			icon: <DocumentText size='18' variant="Bulk" />,
			content: <DocumentiPlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'junior',
			name: "Junior",
			icon: <Profile2User size='18' variant="Bulk" />,
			content: <JuniorPlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'associazioni',
			name: "Associazioni",
			icon: <UserSquare size='18' variant="Bulk" />,
			content: <AssociazioniPlayer profile={profile} privateProfile={privateProfile} userId={id} readOnly={true} />,
		},
		{
			id: 'tesseramenti',
			name: "Tesseramenti",
			icon: <CardIcon size='18' variant="Bulk" />,
			content: <TesseramentiPlayer profile={profile} privateProfile={privateProfile} userId={id} readOnly={true} />,
		}/*,
		{
			id: 'squadre',
			name: "Squadre",
			icon: <People size='18' variant="Bulk" />,
			content: <SquadrePlayer profile={profile} privateProfile={privateProfile}/>,
		},
		{
			id: 'noteprivate',
			name: "Note private",
			icon: <Note size='18' variant="Bulk" />,
			content:<NotePlayer profile={profile} />,
		},*/
	];

	const location = useLocation();
    const query = new URLSearchParams(location.search);
    const [defaultTab, setDefaultTab] = useState(query.get('tab') || tabData[0].name.toLowerCase());

    useEffect(() => {
        const tab = new URLSearchParams(location.search).get('tab');
		if (tab && tab !== defaultTab) {
            setDefaultTab(tab);
        }
    }, [location.search, defaultTab]);

	// In modifica il tab aperto si governa da qui: con un dato da sistemare si apre il suo tab
	const [tabAttivo, setTabAttivo] = useState(defaultTab);
	useEffect(() => { setTabAttivo(defaultTab); }, [defaultTab]);
	const vaiAlGruppo = (gruppo) => { if (TAB_DEL_GRUPPO[gruppo]) setTabAttivo(TAB_DEL_GRUPPO[gruppo]); };

	useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

					setLoadingShowed(true);
                    const [profileData, privateProfileData] = await Promise.all([
                        apiClient.getProfiles(token, id),
						apiClient.getPrivateProfile(token, id)
                    ]);
					setLoadingShowed(false);

					let labelNomeTemp = '';
					if(profileData.idsPlay) {
						labelNomeTemp = profileData.idsPlay.givenName+' '+profileData.idsPlay.familyName;
					} else if(profileData.idsGuru) {
						profileData.idsPlay = profileData.idsGuru;
						labelNomeTemp = profileData.idsPlay.givenName+' '+profileData.idsPlay.familyName;
					}
					setLabelNome(labelNomeTemp);

					setProfile(profileData);
					setPrivateProfile(privateProfileData);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id]);

	const isNotCompleted = profile && profile.idsPlay.profileStatus !== 'COMPLETED' && profile.idsPlay.profileStatus !== 'ACTIVE';

	return (
		<>
			<Modal className="fade" show={loadingShowed} centered>
				<Modal.Body className="text-center">
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
				<div>Caricamento in corso...</div>
				</Modal.Body>
			</Modal>

			<div className="custom-tab-1">
				<Tab.Container {...(modifica.attivo ? { activeKey: tabAttivo, onSelect: (k) => setTabAttivo(k) } : { defaultActiveKey: defaultTab })}>
					<Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
						{tabData.map((data, i) => (
							<Nav.Item as="li" key={i} className="tabMenu">
								<Nav.Link eventKey={data.id.toLowerCase()}>
									{data.name}
								</Nav.Link>
							</Nav.Item>
						))}
					</Nav>
					<Row className="align-items-start mt-4">
						<div className="col-xl-9">
							<Tab.Content>
								{tabData.map((data, i) => (
									<Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
										{data.content}
									</Tab.Pane>
								))}
							</Tab.Content>
							{/* Azioni del player: in fondo alla scheda, l'eliminazione a sinistra; in modifica Annulla e Salva a destra. */}
							<div className="d-flex justify-content-between flex-wrap gap-2 mt-4">
								<Button className="btn btn-danger btn-add" onClick={() => setConfermaElimina(true)}>Elimina player</Button>
								<TastiModifica modifica={modifica} vaiAlGruppo={vaiAlGruppo} />
							</div>
						</div>
						<div className="col-xl-3">
							<Card>
								<Card.Body className="text-center">
									{profile && profile.idsPlay.picture && <DynamicLogo logoUrl={profile ? profile.idsPlay.picture : ''} />}
									{(!profile || !profile.idsPlay.picture) && <img src={DEFAULT_USER} style={{width: '100%'}} alt="" />}
									{/*<img src={playerfoto} style={{width:'60%'}} className="bd-tondo"/>*/}
									<h4 className="text-start mb-0 mt-4 text-warning">{labelNome}</h4>
									{/*<p className="text-start mt-0 pt-0">Socio</p>*/}
									{profile && profile.idsGuru && <Link to={'/superadmin/anagrafiche/maestri/'+profile.idsGuru.userId} className="btn btn-sm btn-booking mt-3"><ArrangeHorizontal variant="Bulk" /><span className='ms-2'>Visualizza profilo Maestro</span></Link>}
									
									{isNotCompleted && (
										<Link to={'#'} className="btn btn-sm btn-profile mt-2">
											<Information variant="Bulk" /><span className='ms-2'>Profilo non completato</span>
										</Link>
									)}
								</Card.Body>
							</Card>
						</div>
					</Row>

				</Tab.Container>
			</div>

			<Modal className="fade" show={confermaElimina} onHide={() => setConfermaElimina(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Eliminare il player?</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Eliminare il player «{labelNome || 'senza nome'}»? L'operazione non si può annullare.
				</Modal.Body>
				<Modal.Footer className="justify-content-between">
					<Button className="btn btn-light btn-add" onClick={() => setConfermaElimina(false)}>Annulla</Button>
					<Button className="btn btn-danger btn-add" onClick={eliminaPlayer}>Elimina</Button>
				</Modal.Footer>
			</Modal>

			<FinestraModificaNonSalvata modifica={modifica} />

			<Modal className="fade" show={!!erroreElimina} onHide={() => setErroreElimina('')} centered>
				<Modal.Header closeButton>
					<Modal.Title>Errore durante l'operazione</Modal.Title>
				</Modal.Header>
				<Modal.Body>{erroreElimina}</Modal.Body>
				<Modal.Footer className="justify-content-center">
					<Button className="btn btn-primary btn-add" onClick={() => setErroreElimina('')}>Chiudi</Button>
				</Modal.Footer>
			</Modal>

		</>
	)
}

export default PlayerEdit;